import { DesignSystem } from "../design-system.js";
import { Button } from "./button.js";
import { ButtonTemplate } from "@fluentui/web-components";
import { styles as ButtonStyles } from "./button.styles.js";
/**
 *
 * @public
 * @remarks
 * HTML Element: <fabric-button>
 */
export const definition = Button.compose({
    name: `${DesignSystem.prefix}-button`,
    template: ButtonTemplate,
    styles: ButtonStyles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
//# sourceMappingURL=button.definition.js.map